import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    Card, CardBody, Col,
} from 'reactstrap';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const reorder = (rows, startIndex, endIndex) => {
    const result = Array.from(rows);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const DistributionDataTable = ({ title, reactTableData, accountingData,sendAccountingAccountToDistribution }) => {
    const { t } = useTranslation('common');

    const [rows, setData] = useState(reactTableData);
    const [isEditable, setIsEditable] = useState(false);
    const [isResizable, setIsResizable] = useState(false);
    const [isSortable, setIsSortable] = useState(false);
    const [isDisabledDragAndDrop, setIsDisabledDragAndDrop] = useState(false);
    const [isDisabledEditable, setIsDisabledEditable] = useState(false);
    const [isDisabledResizable, setIsDisabledResizable] = useState(false);
    const [withDragAndDrop, setWithDragAndDrop] = useState(false);
    const [withPagination, setWithPaginationTable] = useState(true);
    const [withSearchEngine, setWithSearchEngine] = useState(true);

    const handleClickIsEditable = () => {
        if (!withDragAndDrop) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setIsEditable(!isEditable);
    };
    const handleClickIsResizable = () => {
        setIsEditable(false);
        setWithDragAndDrop(false);
        setIsDisabledDragAndDrop(!isDisabledDragAndDrop);
        setIsDisabledEditable(!isDisabledEditable);
        setIsResizable(!isResizable);
    };
    const handleClickIsSortable = () => {
        setIsSortable(!isSortable);
    };
    const handleClickWithDragAndDrop = () => {
        if (!isEditable) setIsDisabledResizable(!isDisabledResizable);
        setIsResizable(false);
        setWithDragAndDrop(!withDragAndDrop);
    };
    const handleClickWithPagination = () => {
        setWithPaginationTable(!withPagination);
    };
    const handleClickWithSearchEngine = () => {
        setWithSearchEngine(!withSearchEngine);
    };

    const updateDraggableData = (result) => {
        const items = reorder(
            rows,
            result.source.index,
            result.destination.index,
        );
        setData(items);
    };

    const updateEditableData = (rowIndex, columnId, value) => {
        setData(old => old.map((item, index) => {
            if (index === rowIndex) {
                return {
                    ...old[rowIndex],
                    [columnId]: value,
                };
            }
            return item;
        }));
    };
    const history = useHistory();

    const tableConfig = {
        isEditable,
        isResizable,
        isSortable,
        withDragAndDrop,
        withPagination,
        /*withSearchEngine,
        placeholder: 'Buscar',*/
        manualPageSize: [30, 60, 90, 120, 150],
        /*useActions: true,
        actions: (data) => ReactTableActions({ data })*/
    };

    const columnsData = [
        {
            Header: "ID",
            accessor: 'id_caja_contable_distribucion',
            Cell: row => (
                <div>
                    {row.value}
                </div>
            )
        },
        {
            Header: "Distribución",
            accessor: 'distribucion',
            Cell: row => (
                <div>
                    {row.value}
                </div>
            )
        },
        {
            Header: "Tipo de Financiación",
            accessor: 'nombre_tipo_financiacion',
            Cell: row => (
                <div>
                    {row.value}
                </div>
            )
        },
        {
            Header: "Caja Destinada",
            accessor: 'id_caja_contable',
            Cell: row => (
                <div style={{width: '300px'}}>
                    <TextField
                        className="medical-material-form__field"
                        label="Cuentas Contables"
                        id="id-simplety-select"
                        style={{ width: '100%' }}
                        select
                        defaultValue={row.value}
                        value={row.value}
                        onChange={(event) => {
                            sendAccountingAccountToDistribution(event.target.value,row.row.original);
                        }}
                    >
                        <MenuItem key={0} value={null}>
                                {`Ninguno`}
                            </MenuItem>
                        {accountingData.map((accountingDataItem) => (
                            <MenuItem key={accountingDataItem.id_caja_contable} value={accountingDataItem.id_caja_contable}>
                                {`${accountingDataItem.codigo} - ${accountingDataItem.descripcion}`}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            )
        },
        {
            Header: "Tipo de Caja",
            accessor: 'nombre_tipo_caja',
            Cell: row => (
                <div>
                    {row.value}
                </div>
            )
        },
        {
            Header: "Estado",
            Cell: row => (
                <div>
                    {row.row.original.id_caja_contable != null ? <b className="text-success">CONFIGURADA</b> : <b className="text-danger">SIN CONFIGURAR</b>}
                </div>
            )
        }
    ];

    useEffect(() => {
    }, []);


    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <div className="react-table__wrapper">

                    </div>
                    <ReactTableBase
                        key={withSearchEngine || isResizable || isEditable ? 'modified' : 'common'}
                        columns={columnsData}
                        data={rows}
                        updateEditableData={updateEditableData}
                        updateDraggableData={updateDraggableData}
                        tableConfig={tableConfig}
                    />
                </CardBody>
            </Card>
        </Col>
    );
};

DistributionDataTable.propTypes = {
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableHeaderData: PropTypes.arrayOf(PropTypes.shape()),
    defaultTableRowData: PropTypes.arrayOf(PropTypes.shape())
};

export default DistributionDataTable;
